import { createAsyncThunk } from "@reduxjs/toolkit";
import { type DeliveryDetail } from "../../../domain/entities/delivery-detail";
import { type DeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getDetail = createAsyncThunk<
  DeliveryDetail,
  string,
  {
    dispatch: DeliveriesDispatch;
    extra: ExtraArgument;
    state: State;
  }
>(thunkTypes.GET_DETAIL, async (requestId, { extra }) => {
  return await extra.deliveryRepo.getDetail(requestId);
});
